import { render } from "./SeatAssignmentMode.vue?vue&type=template&id=6dee464e"
import script from "./SeatAssignmentMode.vue?vue&type=script&lang=js"
export * from "./SeatAssignmentMode.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tel/jcr/ungerboeck_tables/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__